@if (mode === 'renderer') {
  <div
    class="document-list-dc"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor
    }"
  >
    @if (element.fields.title) {
      <div class="document-list-header">
        @if (element.fields.titleIcon) {
          <i [ngClass]="element.fields.titleIcon"></i>
        }
        <span>{{ element.fields.title | translate }}</span>
      </div>
    }
    <div class="document-list-items" [style.max-height.px]="element.fields.maxHeight">
      @for (doc of element.fields.documents; track doc.id) {
        <div class="document-list-item" (click)="downloadDocument(doc)">
          <i class="document-icon" [ngClass]="doc.icon"></i>
          <span class="document-label">{{ doc.label }}</span>
          <button
            type="button"
            class="btn btn-link download-btn"
            (click)="$event.stopPropagation(); downloadDocument(doc)"
          >
            <i class="fa-solid fa-download"></i>
          </button>
        </div>
      }
      @if (edit && element.fields.documents.length === 0) {
        <div class="text-center p-3">Select documents on the right -></div>
      }
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <lib-gung-text-input [gungTranslate]="'TITLE'" [(ngModel)]="element.fields.title"></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <div class="form-group">
                <label for="document-list-title-icon" translate>Title icon</label>
                <select
                  id="document-list-title-icon"
                  class="form-select"
                  [(ngModel)]="element.fields.titleIcon"
                >
                  <option [ngValue]="null">None</option>
                  @for (icon of iconOptions; track icon.class) {
                    <option [ngValue]="icon.class">{{ icon.name }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-number-input
                [gungTranslate]="'Max height (px)'"
                [(ngModel)]="element.fields.maxHeight"
              ></lib-gung-number-input>
            </div>
            <div class="col-12 mb-2">
              <label for="document-list-add-document" translate>Add document</label>
              <div class="d-flex add-document">
                <select id="document-list-add-document" class="form-select" [(ngModel)]="selectedDocumentId">
                  <option value="" disabled translate>Select document</option>
                  @for (doc of selectableDocuments; track doc.id) {
                    <option [value]="doc.id">{{ getDocumentLabel(doc) }}</option>
                  }
                </select>
                <button type="button" class="btn btn-primary ml-1" [disabled]="!selectedDocumentId" (click)="addDocument()">
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
            @for (doc of element.fields.documents; track doc.id; let i = $index) {
              <div class="col-12">
                <div class="selected-document">
                  <div class="d-flex align-items-center">
                    <select class="form-select icon-select" [(ngModel)]="doc.icon" title="{{ 'Icon' | translate }}">
                      @for (icon of iconOptions; track icon.class) {
                        <option [ngValue]="icon.class">{{ icon.name }}</option>
                      }
                    </select>
                    <input
                      type="text"
                      class="form-control ml-1"
                      [(ngModel)]="doc.label"
                      title="{{ 'Label' | translate }}"
                    />
                    <button type="button" class="btn btn-link px-1" [disabled]="i === 0" (click)="moveDocument(i, -1)">
                      <i class="fa-solid fa-arrow-up"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-link px-1"
                      [disabled]="i === element.fields.documents.length - 1"
                      (click)="moveDocument(i, 1)"
                    >
                      <i class="fa-solid fa-arrow-down"></i>
                    </button>
                    <button type="button" class="btn btn-link px-1 text-danger" (click)="removeDocument(i)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                  <small class="text-muted">{{ doc.filename }}</small>
                </div>
              </div>
            }
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <lib-dynamic-page-element-margin-padding
                    [(marginTop)]="element.fields.marginTop"
                    [(marginRight)]="element.fields.marginRight"
                    [(marginBottom)]="element.fields.marginBottom"
                    [(marginLeft)]="element.fields.marginLeft"
                    [(paddingTop)]="element.fields.paddingTop"
                    [(paddingRight)]="element.fields.paddingRight"
                    [(paddingBottom)]="element.fields.paddingBottom"
                    [(paddingLeft)]="element.fields.paddingLeft"
                  ></lib-dynamic-page-element-margin-padding>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.backgroundColor"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                    </div>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-regular fa-file-pdf"></i>
  </div>
}
